<template>
  <div>
    <div v-if="loading" class="text-center py-3">Loading pricing...</div>

    <div v-else>
      <!-- ACTION BAR -->
      <div class="mb-3 d-flex justify-content-between">
        <div>
          <button class="btn btn-outline-primary btn-sm mr-1" data-toggle="modal" data-target="#categoryModal">
            + Add Category
          </button>
          <button class="btn btn-outline-secondary btn-sm" data-toggle="modal" data-target="#subCategoryModal">
            + Add Sub Category
          </button>
        </div>

        <!-- <button class="btn btn-sm btn-outline-primary" @click="addRow">
          + Add Pricing Row
        </button> -->
      </div>
      <!-- EXISTING PRICING (COMPACT TABLE) -->
      <div v-if="existingPricings.length" class="mb-4">
        <div class="table-responsive" style="max-height: 400px; overflow-y: auto">
          <table class="table table-striped table-hover mb-0">
            <thead class="table-dark">
              <tr>
                <th>Category</th>
                <th>Sub Category</th>
                <th>Amount</th>
                <th>GST</th>
                <th>Allowed Domains</th>
                <th>Notes</th>
                <th class="text-center" style="width: 80px">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="p in existingPricings" :key="p.id">
                <td class="font-weight-medium">
                  {{ catMap[p.event_category_id] }}
                </td>

                <td>
                  {{
                    p.event_sub_category_id
                      ? subCatMap[p.event_sub_category_id]
                      : "N/A"
                  }}
                </td>

                <td class="font-weight-bold">
                  <span v-if="p.is_free">Free</span>
                  <span v-else>₹{{ p.amount.toLocaleString("en-IN") }}</span>
                </td>

                <td>
                  <span v-if="p.is_gst_applicable"> {{ p.gst_rate }}% </span>
                  <span v-else class="text-muted"> Not Applicable </span>
                </td>

                <td class="small">
                  <span v-if="p.allowed_domains && p.allowed_domains.length">
                    {{ p.allowed_domains.join(', ') }}
                  </span>
                  <span v-else class="text-muted">All domains</span>
                </td>

                <td class="text-muted small">
                  {{ p.notes || "-" }}
                </td>

                <td class="text-center">
                  <div class="custom-control custom-switch ">
                    <input @change="updateIsActive($event,p)" type="checkbox" class="custom-control-input" :id="'customSwitch1' + p.id" :checked="p.is_active">
                    <label class="custom-control-label" :for="'customSwitch1' + p.id">
                    </label>
                    <span class="switch-label">Active</span>
                  </div>

                  <button class="btn btn-sm btn-outline-danger mt-1" title="Delete Pricing"
                    @click="deletePricing(p.id)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ADD / UPDATE PRICING -->
      <div class="card mb-2" v-for="(r, i) in rows" :key="i">
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <label>Category *</label>
              <select class="form-control" v-model="r.event_category_id">
                <option value="">Select</option>
                <option v-for="c in categories" :value="c.id">
                  {{ c.name }}
                </option>
              </select>
            </div>

            <div class="col-md-2">
              <label>Sub Category</label>
              <select class="form-control" v-model="r.event_sub_category_id">
                <option value="">Select</option>
                <option v-for="s in subCategories" :value="s.id">
                  {{ s.name }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="d-block">Is Free Pricing?</label>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="r.is_free" @change="onFreeToggle(r)"  />
                <label class="form-check-label">Free</label>
              </div>
            </div>

            <div class="col-md-2">
              <label>Amount *</label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control mr-2" v-model.number="r.amount"
                  placeholder="Amount (Per Head)" :disabled="r.is_free" style="flex: 1" />
               
              </div>
            </div>
           

           


            <div class="col-md-2" v-if="!r.is_free">
              <label class="d-block">GST?</label>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="r.is_gst_applicable"
                  @change="onGstToggle(r)" />
                <label class="form-check-label">Applicable</label>
              </div>
            </div>

            <div class="col-md-1" v-if="!r.is_free">
              <label>GST %</label>
              <input type="number" placeholder="Enter GST Rate" class="form-control" v-model.number="r.gst_rate"
                :disabled="!r.is_gst_applicable" />
            </div>

            <div class="col-md-1 d-flex align-items-end">
              <button class="btn btn-outline-danger w-100" @click="removeRow(i)">
                X
              </button>
            </div>

            <div class="col-md-12 mt-2">
              <label>Allowed Email Domains</label>
              <input
                type="text"
                class="form-control"
                v-model="r.allowed_domains_text"
                placeholder="e.g. staloysius.edu.in, gmail.com (optional)"
              />
              <small class="text-muted">Leave empty to allow all email domains. Comma-separated when restricting.</small>
            </div>

            <div class="col-md-12 mt-2">
              <label>Notes</label>
              <textarea class="form-control" rows="2" placeholder="Optional notes" v-model="r.notes"></textarea>
            </div>
          </div>
          <button class="btn btn-primary mt-2" :disabled="saving" @click="saveAll">
            {{ saving ? "Saving…" : "Save Pricing" }}
          </button>
        </div>
      </div>

      <!-- CATEGORY MODAL -->
      <div class="modal fade" id="categoryModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5>Add Category</h5>
              <button class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <input class="form-control mb-2" placeholder="Name" v-model="newCategory.name" />
              <textarea class="form-control" placeholder="Description" v-model="newCategory.description"></textarea>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="createCategory">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- SUB CATEGORY MODAL -->
      <div class="modal fade" id="subCategoryModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5>Add Sub Category</h5>
              <button class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <input class="form-control mb-2" placeholder="Name" v-model="newSubCategory.name" />
              <textarea class="form-control" placeholder="Description" v-model="newSubCategory.description"></textarea>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="createSubCategory">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "fetchUrl",
    "saveUrl",
    "deleteUrlTemplate",
    "updateStatusUrlTemplate",
    "createCategoryUrl",
    "createSubcategoryUrl",
  ],

  data() {
    return {
      loading: true,
      saving: false,

      categories: [],
      subCategories: [],
      existingPricings: [],
      rows: [],

      newCategory: { name: "", description: "" },
      newSubCategory: { name: "", description: "" },
    };
  },

  computed: {
    catMap() {
      const m = {};
      this.categories.forEach((c) => (m[c.id] = c.name));
      return m;
    },
    subCatMap() {
      const m = {};
      this.subCategories.forEach((s) => (m[s.id] = s.name));
      return m;
    },
  },

  methods: {
    updateIsActive(event, pricing) {
      const isActive = event.target.checked;
      console.log(pricing);
      axios
        .put(this.updateStatusUrlTemplate.replace("PRICING_ID", pricing.id), {
          is_active: isActive,
        })
        .then(() => {
          this.swal("success", "Pricing updated successfully");
          pricing.is_active = isActive;
        })
        .catch(() => {
          this.swal("error", "Failed to update pricing");
          event.target.checked = !isActive; // revert checkbox state
        });
    },
    swal(icon, title) {
      $(".modal").modal("hide");
      Swal.fire({
        icon,
        title,
        timer: 2000,
        showConfirmButton: false,
      });
    },

    addRow() {
      this.rows.push({
        event_category_id: "",
        event_sub_category_id: "",
        amount: "",
        is_free: false,
        is_gst_applicable: false,
        gst_rate: null,
        notes: "",
        allowed_domains_text: "",
      });
    },

    onFreeToggle(row) {
      if (row.is_free) {
        row.amount = 0;
        row.is_gst_applicable = false;
        row.gst_rate = 0;
      }
    },

    removeRow(i) {
      this.rows.splice(i, 1);
    },

    onGstToggle(row) {
      if (!row.is_gst_applicable) {
        row.gst_rate = 0;
      }
    },

    async fetchData() {
      try {
        const res = await axios.get(this.fetchUrl);
        this.categories = res.data.categories;
        this.subCategories = res.data.subCategories;
        this.existingPricings = res.data.pricings;

        if (!this.rows.length) {
          this.addRow();
        }
      } catch {
        this.swal("error", "Failed to load pricing");
      } finally {
        this.loading = false;
      }
    },

    async createCategory() {
      try {
        await axios.post(this.createCategoryUrl, this.newCategory);

        this.newCategory = { name: "", description: "" };
        $("#categoryModal").modal("hide");

        await this.reloadCategories();

        this.swal("success", "Category created");
      } catch (e) {
        this.swal("error", "Failed to create category");
      }
    },

    async createSubCategory() {
      try {
        await axios.post(this.createSubcategoryUrl, this.newSubCategory);

        this.newSubCategory = { name: "", description: "" };
        $("#subCategoryModal").modal("hide");

        await this.reloadSubCategories();

        this.swal("success", "Sub category created");
      } catch (e) {
        this.swal("error", "Failed to create sub category");
      }
    },
    async deletePricing(id) {
      const confirm = await Swal.fire({
        title: "Are you sure?",
        text: "This pricing will be permanently deleted",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });

      if (!confirm.isConfirmed) {
        return;
      }

      try {
        const url = this.deleteUrlTemplate.replace("PRICING_ID", id);
        await axios.delete(url);

        this.fetchData();

        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Pricing deleted successfully",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Unable to delete pricing",
        });
      }
    },

    parseDomains(text) {
      return text
        .split(",")
        .map((d) => d.trim().replace(/^@+/, "").toLowerCase())
        .filter((d) => d.length > 0);
    },

    async saveAll() {
      const rowsToSave = this.rows.map((row) => {
        const allowed_domains = this.parseDomains(row.allowed_domains_text || "");
        return {
          event_category_id: row.event_category_id,
          event_sub_category_id: row.event_sub_category_id,
          amount: row.amount,
          is_free: row.is_free,
          is_gst_applicable: row.is_gst_applicable,
          gst_rate: row.gst_rate,
          notes: row.notes,
          allowed_domains,
        };
      });

      this.saving = true;
      try {
        await axios.post(this.saveUrl, { rows: rowsToSave });
        this.rows = [];
        await this.fetchData();
        this.swal("success", "Pricing saved");
      } catch (e) {
        const message = e.response?.data?.message || "Failed to save pricing";
        this.swal("error", message);
      } finally {
        this.saving = false;
      }
    },

    async reloadCategories() {
      const res = await axios.get(this.fetchUrl);
      this.categories = res.data.categories;
    },

    async reloadSubCategories() {
      const res = await axios.get(this.fetchUrl);
      this.subCategories = res.data.subCategories;
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>
<style>
/* Professional Table Styling */
.table {
  margin-bottom: 0;
  border: 1px solid #dee2e6;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  border-top: none;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  padding: 1rem 0.75rem;
  vertical-align: middle;
  background-color: #f8f9fa;
  color: #495057;
}

.table tbody td {
  padding: 0.875rem 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  font-size: 0.875rem;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.025);
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

/* Typography */
.font-weight-medium {
  font-weight: 500;
}

.font-weight-bold {
  font-weight: 700;
}

/* Button Styling */
.btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  transition: all 0.15s ease-in-out;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #fff;
}

.btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

/* Table Container */
.table-responsive {
  border-radius: 0.375rem;
  overflow: hidden;
  border: 1px solid #dee2e6;
}

.table-responsive::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive adjustments */
@media (max-width: 768px) {

  .table thead th,
  .table tbody td {
    padding: 0.5rem;
    font-size: 0.8rem;
  }

  .table-responsive {
    font-size: 0.875rem;
  }
}

/* Text styling */
.text-muted {
  color: #6c757d !important;
}

.small {
  font-size: 80%;
}
</style>